import { Injectable, inject } from '@angular/core';
import { SiaComponentConfigPerspectives } from '../interfaces/sia-component-config-perspectives';
import { SiaCustomControlConfiguration } from '../interfaces/sia-template-configuration';
import { SiaHttpService } from '../services/http.service';
@Injectable({
  providedIn: 'root',
})
export class SiaComponentConfigApi {
  private http = inject(SiaHttpService);

  private _controller: string = 'component-config';

  async isModuleEnabled(moduleId: string): Promise<boolean> {
    try {
      const result = await this.http.get(`utils/is-module-enabled`, {
        params: { moduleId },
      });
      return result;
    } catch (error) {
      console.error(`Error checking if module ${moduleId} is enabled:`, error);
      return false;
    }
  }

  // OK Server
  getCustomControlUsages(customControlId: string) {
    return this.http.getCache(
      `${this._controller}/custom-control-usages/${customControlId}`,
      {},
      'customcontrol',
    );
  }

  //ok server
  async deleteCustomControl(customControlId: string) {
    await this.http.deleteOnlyCache('customcontrol');
    await this.http.deleteOnlyCache('perspectives');
    return this.http.delete(
      `${this._controller}/custom-control/${customControlId}`,
      {},
    );
  }

  //Ok SERVER
  async updateComponentPerspective(
    componentPerspective: SiaComponentConfigPerspectives,
  ): Promise<SiaComponentConfigPerspectives> {
    await this.http.deleteOnlyCache(
      `perspectives-` +
        componentPerspective.configType +
        (componentPerspective.componentId ?? ''),
    );
    return this.http.put(
      `${this._controller}/perspectives`,
      componentPerspective,
    );
  }
  // OK server
  async setComponentPerspective(
    componentPerspective: SiaComponentConfigPerspectives,
  ): Promise<SiaComponentConfigPerspectives> {
    await this.http.deleteOnlyCache(
      `perspectives-` +
        componentPerspective.configType +
        (componentPerspective.componentId ?? ''),
    );
    return this.http.post(
      `${this._controller}/perspectives`,
      componentPerspective,
    );
  }
  // OK Server
  async updateCustomControlConfiguration(
    templateConfig: SiaCustomControlConfiguration,
  ) {
    await this.http.deleteOnlyCache('customcontrol');
    await this.http.deleteOnlyCache('perspectives');
    return this.http.put(`${this._controller}/custom-control/`, templateConfig);
  }
  // OK server
  getCustomControl(templateId: string) {
    return this.http.getCache(
      `${this._controller}/custom-control/${templateId}`,
      {},
      'customcontrol',
    );
  }
  // OK SERVER
  getDefaultPerspective(type: string, componentId: string, deviceType: string) {
    return this.http.getCache(
      `${this._controller}/perspectives/defaults/${type}/${componentId}/${deviceType}`,
      {},
      `perspectives-` + type + componentId,
    );
  }
  // Ok SERVER
  getComponentPerspectives(type: string, componentId: string) {
    return this.http.getCache(
      `${this._controller}/perspectives/${type}/comp/${componentId}`,
      {},
      `perspectives-` + type + componentId,
    );
  }
  // OK SERVER
  async deletePerspective(id: string): Promise<boolean> {
    await this.http.deleteOnlyCache(`perspectives`);
    return this.http.delete(`${this._controller}/perspectives/${id}`, {});
  }
  //OK server
  async updateComponentPerspectiveInfo(data: SiaComponentConfigPerspectives) {
    await this.http.deleteOnlyCache(`perspectives`);
    return this.http.put(`${this._controller}/perspectives/info`, data);
  }
  //OK server
  getPerspective(id: string) {
    return this.http.get(
      `${this._controller}/perspective/${id}`,
      {},
      `perspectives`,
    );
  }

  getPerspectives(type: string): Promise<SiaComponentConfigPerspectives[]> {
    return this.http.get(
      `${this._controller}/perspectives/${type}`,
      {},
      `perspectives`,
    );
  }

  //OK Server
  getPerspectivesInfo(type: string) {
    return this.http.get(
      `${this._controller}/perspectives/${type}/info`,
      {},
      'perspectives',
    );
  }

  // OK server
  clonePerspective(perspectiveId: any, cloneFrom: any) {
    return this.http.put(
      `${this._controller}/perspectives/clone/${perspectiveId}/${cloneFrom}`,
      {},
    );
  }
}
